<template>
  <div class="custom-key-page">
    <basiCcontainer>
      <template #head>
        <Banner></Banner>
        <div class="search-table">
          <div class="search-table-tool">
            <el-input prefix-icon="iconfont iconicon_search1" @input="searchChange" class="fliter-input" v-model="ruleForm.keyword" size="mini" placeholder="搜索字段名称" clearable @keyup.enter.native="searchChange"></el-input>
          </div>
          <div>
            <el-button size="mini" type="primary" @click="addNewKey">新增字段</el-button>
            <!-- <el-button size="mini" type="primary" @click="showPreView">预览</el-button> -->
          </div>
        </div>
      </template>
      <template>
        <div class="table-box">
          <table class="table">
            <thead>
              <th  style="width: 30%;">字段名称</th>
              <th>字段类型</th>
              <th style="width: 30%;">描述</th>
              <th>状态</th>
              <th style="width: 150px">操作</th>
            </thead>
            <vuedraggable element="tbody" v-bind="dragOptions()" handle=".drag" :list="templateInfo" @end="onListEnd">
              <tr class="list-item" v-for="(item, index) in templateInfo" :key="item.id" :data-id="item.id" :data-show="item.is_show">
                <td  style="width: 30%;"><i class="icon iconfont iconicon_drag_order tableIconHover drag"></i>{{item.component_name_in_template}}</td>
                <td><i class="icon iconfont code-tip" :class="keyIcon[item.component_code] || 'iconicon_custom_field'"></i>{{item.standard_component.standard_component_name}}</td>
                <td  style="width: 30%;">{{item.component_desc_in_template}}</td>
                <td>{{item.is_show == 1 ? '使用中' :'未使用'}}</td>
                <td style="width: 150px">
                  <span @click="editCustom(item)" style="margin-right: 50px;" class="letterHover">编辑</span>
                  <span @click="delCustom(item)" class="text-red">{{item.is_show == 1 ? '禁用' :'启用'}}</span>
                </td>
              </tr>
            </vuedraggable>
          </table>
        </div>
      </template>
    </basiCcontainer>
    <!-- <el-drawer :title="isEdit ? '编辑字段' : '新建字段'" :visible.sync="dialogVisible" :wrapperClosable="false" :append-to-body="true" size="500px">
      <dialogEle :dataset="dataset" v-if="dialogVisible" @success="success" :editData="editData" :dialogVisible="dialogVisible" @cancel="dialogVisible = false" :isEdit="isEdit" :projectId="project_id"></dialogEle>
    </el-drawer> -->
    <el-dialog :title="isEdit ? '编辑字段' : '新建字段'" :visible.sync="dialogVisible" width="30%" :wrapperClosable="false" :close-on-click-modal="false" :append-to-body="false">
      <dialogEle :dataset="dataset" v-if="dialogVisible" @success="success" :editData="editData" :dialogVisible="dialogVisible" @cancel="dialogVisible = false" :isEdit="isEdit" :projectId="project_id"></dialogEle>
    </el-dialog>
  </div>
</template>
<script>
import dialogEle from './dialog'
import customService from '@/services/api/customKey/customKey'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import Banner from '@/components/banner/'
import vuedraggable from "vuedraggable";
export default {
  components: {
    dialogEle,
    Banner,
    vuedraggable
  },
  data() {
    return {
      timer: '',
      dialogVisible: false,
      loading: false,
      ruleForm: {
        keyword: ''
      },
      project_id: '',
      dataset: [],
      editData: {},
      isEdit: false,
      previewDialog: false,
      templateInfo: [],
      taskInfo: {},
    }
  },
  computed: {
    nothing() {
      return {
        tip: this.ruleForm.keyword ? '暂无搜索内容' : '暂无字段信息，快去添加自定义字段吧',
        type: this.ruleForm.keyword ? 'img_search' : 'img_add_task',
        btnText: this.ruleForm.keyword ? '' : '新增字段',
        permission: ''
      }
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.init()
  },
  methods: {
    ...mapActions('customKey/customKey', ['deleteKey', 'getStandardComponents', 'changeHeadTemplate']),
    ...mapActions('project/project', ['getProjectUnreadMessage', 'setProjectMessageIsRead']),
    ...mapMutations('customKey/customKey', ['SET_PROJECTID']),
    success() {
      this.SET_PROJECTID('')
      this.init()
      this.dialogVisible = false
    },
    init() {
      this.getTableList()
      this.getStandardComponents({ number: 999, page: 1 })
    },
    getTableList() {
      this.loading = true
      let parmas = {
        number: 999,
        page: 1,
        project_id: this.project_id,
      }
      customService.getprojectTemplate(parmas).then(res => {
        this.dataset = JSON.parse(JSON.stringify(res.data))
        if (res.data && res.data.length > 0) {
          customService.getTemplateDetail({ template_id: res.data[0].id, keyword: this.ruleForm.keyword }).then(res => {
            // this.$refs.commonTable.selfPageSplit(res.template_standard_components)
            this.templateInfo = JSON.parse(JSON.stringify(res.template_standard_components))
            this.loading = false
          })
        } else {
          // this.$refs.commonTable.selfPageSplit([])
          this.templateInfo = []
          this.loading = false
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    editCustom(data) {
      this.editData = JSON.parse(JSON.stringify(data))
      this.dialogVisible = true
      this.isEdit = true
    },
    radioChange(item) {
      let temp = this.dataset[0].template_standard_components.map(res => {
        if (res.id != item.id) {
          return {
            component_id_in_template: res.id,
            sort: res.sort,
            is_show: Number(res.is_show)
          }
        }
      }).filter(res => res)
      temp.push({
        component_id_in_template: item.id,
        sort: item.sort,
        is_show: Number(!Boolean(item.is_show))
      })
      let parmas = {
        template_id: item.template_id,
        standard_components: temp
      }
      customService.updateTemplateStandardComponentOtherContent(parmas).then(res => {
        this.SET_PROJECTID('')
        this.init()
      })
    },
    delCustom(data) {
      this.radioChange(data)
    },
    searchChange() {
      console.log('------------------------')
      clearInterval(this.timer)
      this.timer = ''
      this.timer = setInterval(() => {
        this.getTableList()
        clearInterval(this.timer)
        this.timer = ''
      }, 300)
    },
    addNewKey() {
      this.isEdit = false
      this.dialogVisible = true
    },
    showPreView() {
      this.previewDialog = true
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
      }
    },
    async onListEnd(e) {
      let eles = e.target.getElementsByClassName('list-item');
      let length = eles.length;
      let temp = [];
      for (let i = 0; i < length; i++) {
        temp.push({
          component_id_in_template: eles[i].dataset.id,
          sort: i,
          is_show: Number(eles[i].dataset.show),
        });
      }
      let params = {
        template_id: this.templateInfo[0].template_id,
        standard_components: temp,
      };
      await customService.updateTemplateStandardComponentOtherContent(params)
      await this.changeHeadTemplate({ number: 999, page: 1, project_id: this.project_id })
    }
  }
}
</script>
<style lang="scss">
.custom-key-page{
  .banner-project-setting {
    padding: 0 32px;
  }
  .search-table-tool{
    margin-right:20px;
    .fliter-input {
      width: 360px;
    }
  }
  .search-table{
    display: flex;
    align-items: center;
    height: 48px;
    padding-left: 32px;
  }
  .footer-btns{
    border:0 none;
  }
  .basic-container .search-box::before {
    display: none;
  }
  .table-box {
    padding: 0 32px;
    display: flex;
  }
  .table {
    width: 0;
    flex: 1;
    font-size: 14px;
    thead {
      height: 48px;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      th:first-child {
        padding-left: 52px;
      }
    }
    th {
      text-align: left;
      color: rgba(32, 32, 32, 0.6);

    }
    tr {
      height: 48px;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      td:first-child {
        padding-left: 52px;
      }
      td {
        position: relative;
        .drag {
          position: absolute;
          color: #A6A6A9;
          left: 16px;
          top: 50%;
          transform: translate(0, -50%);
          font-size: 14px;
        }
      }
      .code-tip {
        font-size: 14px;
        margin-right: 16px;
      }
    }
  }
}
</style>
